import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";

const MARGIN = 10;

const snap = (el) => html2canvas(el, { scale: 1.6, backgroundColor: "#ffffff", logging: false, windowWidth: Math.max(el.scrollWidth + 40, document.documentElement.clientWidth) });

const slice = (canvas, y, h) => {
  const part = document.createElement("canvas");
  part.width = canvas.width;
  part.height = h;
  const ctx = part.getContext("2d");
  ctx.fillStyle = "#ffffff";
  ctx.fillRect(0, 0, part.width, h);
  ctx.drawImage(canvas, 0, y, canvas.width, h, 0, 0, canvas.width, h);
  return part.toDataURL("image/jpeg", 0.88);
};

export async function exportAgentPdf({ chartEl, tableEl, title, period, filters }) {
  const pdf = new jsPDF({ orientation: "landscape", unit: "mm", format: "a4", compress: true });
  const pageW = pdf.internal.pageSize.getWidth();
  const pageH = pdf.internal.pageSize.getHeight();
  const usableW = pageW - MARGIN * 2;

  pdf.setFont("helvetica", "bold").setFontSize(16).text(title, MARGIN, MARGIN + 6);
  pdf.setFont("helvetica", "normal").setFontSize(11).text(period, MARGIN, MARGIN + 13);
  let y = MARGIN + 19;
  if (filters) {
    const lines = pdf.setFontSize(9).splitTextToSize(filters, usableW);
    pdf.setTextColor(90).text(lines, MARGIN, y).setTextColor(0);
    y += lines.length * 4 + 2;
  }

  if (chartEl) {
    const canvas = await snap(chartEl);
    let w = usableW;
    let h = (canvas.height * w) / canvas.width;
    const maxH = pageH - y - MARGIN;
    if (h > maxH) { w = (w * maxH) / h; h = maxH; }
    pdf.addImage(canvas.toDataURL("image/jpeg", 0.9), "JPEG", MARGIN, y, w, h);
  }

  if (tableEl) {
    const canvas = await snap(tableEl);
    const mmPerPx = usableW / canvas.width;
    pdf.addPage();
    pdf.setFont("helvetica", "bold").setFontSize(12).text(`${title} — ${period}`, MARGIN, MARGIN + 4);
    let top = MARGIN + 8;
    let offset = 0;
    while (offset < canvas.height) {
      const slicePx = Math.min(Math.floor((pageH - MARGIN - top) / mmPerPx), canvas.height - offset);
      pdf.addImage(slice(canvas, offset, slicePx), "JPEG", MARGIN, top, usableW, slicePx * mmPerPx);
      offset += slicePx;
      if (offset < canvas.height) { pdf.addPage(); top = MARGIN; }
    }
  }
  pdf.save(`${title.replace(/[^\w-]+/g, "_")}.pdf`);
}
